import {
  WebGLRenderer,
  ACESFilmicToneMapping,
  sRGBEncoding,
  PCFSoftShadowMap,
  AdditiveBlending
} from 'three'

import {
  EffectComposer,
  RenderPass,
  EffectPass,
  DepthOfFieldEffect,
  SSAOEffect,
  BloomEffect,
  SelectiveBloomEffect,
  SMAAEffect,
  SMAAPreset,
  NormalPass,
  BlendFunction,
  KernelSize,
  EdgeDetectionMode
} from 'postprocessing'

// import { gui, guiObj } from '@/utils/gui'

export class Renderer {
  constructor (scene, camera) {
    this.scene = scene
    this.camera = camera

    this.resize = this.resize.bind(this)
    this.render = this.render.bind(this)

    this.webGLRenderer = new WebGLRenderer({
      antialias: false,
      alpha: true,
      depth: true,
    })

    this.webGLRenderer.setClearColor(0xffffff, 1)
    this.webGLRenderer.outputEncoding = sRGBEncoding
    this.webGLRenderer.toneMapping = ACESFilmicToneMapping
    this.webGLRenderer.gammaFactor = 2.2
    this.webGLRenderer.setPixelRatio( window.devicePixelRatio > 2 ? 2 : window.devicePixelRatio )
    this.webGLRenderer.localClippingEnabled = false
    this.webGLRenderer.shadowMap.enabled = true
    this.webGLRenderer.shadowMap.type = PCFSoftShadowMap


    this.smaaEffect = new SMAAEffect(
      Object.assign(new Image(), { src: SMAAEffect.searchImageDataURL }),
      Object.assign(new Image(), { src: SMAAEffect.areaImageDataURL }),
      SMAAPreset.ULTRA,
      EdgeDetectionMode.LUMA
    )

    this.bloomEffect = new BloomEffect({
      blendFunction: BlendFunction.SCREEN,
      kernelSize: KernelSize.MEDIUM,
      luminanceThreshold: 0.4,
      luminanceSmoothing: 0.1,
      height: 480
    })
    this.bloomEffect.intensity = 0
    this.bloomEffect.blurPass.scale = 1
    this.bloomEffect.luminanceMaterial.threshold = .09
    this.bloomEffect.luminanceMaterial.smoothing = .06

    this.renderPass = new RenderPass(scene, camera)
    this.renderPass.renderToScreen = false

    this.effectPass = new EffectPass(camera,
      this.smaaEffect,
      this.bloomEffect
    )
    this.effectPass.renderToScreen = true

    this.composer = new EffectComposer(this.webGLRenderer)
    this.composer.addPass(this.renderPass)
    this.composer.addPass(this.effectPass)


    // const guiBloom = gui.addFolder('Bloom')
    // guiBloom.add(this.bloomEffect, 'intensity').min(0).max(5).step(0.01)    // 2,5
    // guiBloom.add(this.bloomEffect.blurPass, 'scale').min(0).max(2).step(0.0001)    // 0.6
    // guiBloom.add(this.bloomEffect.luminanceMaterial, 'threshold').min(0).max(1).step(0.01)     // 0.09
    // guiBloom.add(this.bloomEffect.luminanceMaterial, 'smoothing').min(0).max(1).step(0.01)      // 0.06

  }

  get canvas () {
    return this.webGLRenderer.domElement
  }

  set bloom (value) {
    this.bloomEffect.intensity = value * 1.5
  }

  resize ({width, height}) {
    this.webGLRenderer.setSize(width, height)
    this.composer.setSize(width, height)

    this.camera.aspect = width / height
    this.camera.updateProjectionMatrix()
  }

  render () {
    this.composer.render()
  }

  destroy () {
    this.composer.dispose()
  }
}
